import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyStateComponent } from './empty-state.component';
import { AssetPipeModule } from '../asset-pipe/asset-pipe.module';

@NgModule({
  declarations: [
    EmptyStateComponent
  ],
  imports: [
    CommonModule,
    AssetPipeModule
  ],
  exports: [
    EmptyStateComponent
  ],
})
export class EmptyStateModule { }
